export var iconLoader = {
  "children": [{
    "name": "path",
    "type": "element",
    "value": "",
    "attributes": {
      "fill": "currentColor",
      "d": "M24 1a2.347 2.347 0 1 1 0 4.694 18.306 18.306 0 1 0 13.359 5.792 2.347 2.347 0 1 1 3.426-3.21A23 23 0 1 1 24 1"
    },
    "children": []
  }],
  "id": "icon-loader",
  "viewBox": "0 0 48 48"
};